import { DS_TOKENS } from 'constants/styled.contants';
import React, { MouseEvent, PropsWithChildren, useRef, useState } from 'react';
import * as Styled from './styled';

const DraggableScroll: React.FC<PropsWithChildren<{ listGap?: string; listPadding?: string }>> = ({
  children,
  listGap,
  listPadding,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    /* istanbul ignore else */
    if (containerRef?.current) {
      setIsDragging(true);
      setStartX(e.pageX - containerRef.current.offsetLeft);
      setScrollLeft(containerRef.current.scrollLeft);
    }
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;
    /* istanbul ignore else */
    if (containerRef?.current) {
      e.preventDefault();
      const x = e.pageX - containerRef.current.offsetLeft;
      const walk = x - startX;
      containerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  return (
    <Styled.Wrapper
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      data-testid="draggable-container"
      listGap={listGap}
      listPadding={listPadding}
    >
      {children}
    </Styled.Wrapper>
  );
};

DraggableScroll.defaultProps = {
  listGap: DS_TOKENS.spacing.km2,
  listPadding: `0`,
};

export default DraggableScroll;
